<template>
  <div class="layout">
    <!-- 企业信息 -->
    <div
      class="layout-header-tab"
      style="width: calc(100% - 13.25rem); z-index: 1">
      <span
        @click="tabs.callback(item.key)"
        class="tab"
        v-for="item in tabs.items"
        :class="{ active: active == item.key }"
        :key="item.key">
        {{ item.title }}
      </span>
    </div>
    <router-view ref="content" class="layout content" />
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
export default {
  name: 'companySettings',
  data() {
    return {
      tabs: {
        items: [
          {
            key: '1',
            title: '企业管理'
          }, {
            key: '2',
            title: '总量设置'
          }, {
            key: '3',
            title: '区域核定量设置'
          },/* {
            key: '4',
            title: '站点同步'
          },*/ {
            key: '5',
            title: '调度信息'
          }, {
            key: '6',
            title: '租还信息'
          }, {
            key: '7',
            title: '车辆信息'
          }, {
            key: '8',
            title: '站外还车扣费'
          }, {
            key: '9',
            title: '骑行订单信息'
          }
        ],
        callback: (key) => {
          let path = ''
          switch (key) {
            case '1':
              path = '/CompanyManagement/company/'
              break
            case '2':
              path = '/CompanyManagement/sum/'
              break
            case '3':
              path = '/CompanyManagement/check/'
              break
            case '4':
              path = '/CompanyManagement/siteSync/'
              break
            case '5':
              path = '/CompanyManagement/dispatchSync/'
              break
            case '6':
              path = '/CompanyManagement/requestSync/'
              break
            case '7':
              path = '/CompanyManagement/bikeSync/'
              break
            case '8':
              path = '/CompanyManagement/bikeOutSideFee/'
              break
            case '9':
              path = '/CompanyManagement/bikeRideOrder/'
              break
          }
          if (this.selfAreaId) {
            path += this.selfAreaId
          }
          if (key !== '1') {
            // 如果不在企业管理 判断区域权限
            if (this.userLevel == 2) {
              this.$router.push(path)
            } else {
              this.$message.warning('请选择复合区及下级区域！')
            }
          } else {
            this.$router.push(path)
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'userLevel']),
    active() {
      switch (this.$route.name) {
        case 'company':
          return '1'
        case 'sum':
          return '2'
        case 'check':
          return '3'
        case 'siteSync':
          return '4'
        case 'dispatchSync':
          return '5'
        case 'requestSync':
          return '6'
        case 'bikeSync':
          return '7'
        case 'bikeOutSideFee':
          return '8'
        case 'bikeRideOrder':
          return '9'
        default:
          return '1'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.system-setting {
  background: rgba(240, 242, 245, 1);
  width: 100%;
  height: 100%;
}

.layout-header-tab {
  position: fixed;
  top: 56px;
  width: 100%;
  background-color: #fff;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  left: 8px;

  .tab {
    font-size: 12px;
    color: #999;
    padding: 0 16px;
    cursor: pointer;

    &:hover,
    &.active {
      font-weight: bold;
      color: #333;
    }
  }
}

.content {
  margin-top: 96px;
  background: #f0f2f5;
}
</style>
